export const CATEGORIES = {
    ALL: "all",
    UOW: "University of Warwick",
    ANIMATION: "Animation",
    ILLUSTRATION: "Illustration",
    GRAPHIC_DESIGN: "Graphic Design",
    PERSONAL: "Personal",
    KEW_GARDENS: "Kew Gardens",
    DESIGN: "Design"
}